import Slider from "./_slider";
import app from "../_app";

const product = document.querySelector('.js-page-product');

if(product) {
    if(app.viewport.isEqualOrSmallerThan('md')) {
        const productImageSlider = product.querySelector('.js-product-image-slider');

        new Slider(productImageSlider, {
            arrows: true,
        });
    }

    const colorName = product.querySelector('.js-product-color-name');
    const colors = [...product.querySelectorAll('.js-product-color')];

    colors.map(color => {
        color.addEventListener('mouseenter', () => colorName.innerText = color.dataset.colorName);
        color.addEventListener('mouseleave', () => colorName.innerText = colorName.dataset.colorName);
    });

    const content = product.querySelector('.js-product-content');

    if(content) {
        const tabs = [...content.querySelectorAll('.js-product-content-tab')];
        const contents = [...content.querySelectorAll('.js-product-content-content')];

        tabs.map((tab, index) => tab.addEventListener('click', () => {
            if(!tab.hasAttribute('data-current')) {
                tabs.map(t => t.removeAttribute('data-current'));
                tab.setAttribute('data-current', '');

                contents.map((content, contentIndex) => {
                    if(contentIndex === index) {
                        content.setAttribute('data-current', '');
                    } else {
                        content.removeAttribute('data-current');
                    }
                })
            }
        }))
    }
}
